import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { LayoutState } from './layout.state';
import { getters } from './layout.getters';
import { mutations } from './layout.mutations';
import { actions } from './layout.actions';

VueXHelper.setStoreModule(Module.DASHBOARD_LAYOUT, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new LayoutState(),
  getters,
  mutations,
  actions,
};
